import { useLocation, useNavigate, useParams } from "react-router-dom";

import Categories from "./Categories";
import Content from "./Content";
import { USER_MANUAL_LINKS } from "config/userManualLinks";
import useHelpBackNavigation from "hooks/useHelpBackNavigation";
import { USER_MANUAL_PATH } from "router/pathName";
import type { HelpLocationState } from "hooks/useHelpBackNavigation";

const UserManualPage = () => {
  useHelpBackNavigation();

  const navigate = useNavigate();
  const location = useLocation();
  const { categoryId } = useParams();

  const categoryNumber = categoryId ? Number(categoryId) : undefined;
  const selectedCategory = Number.isNaN(categoryNumber) ? undefined : categoryNumber;

  const handleCategorySelect = (categoryId: number) => {
    const state = location.state as HelpLocationState | null;
    navigate(`${USER_MANUAL_PATH}/${categoryId}`, {
      state: {
        ...(state?.from ? { from: state.from } : {}),
        origin: USER_MANUAL_PATH,
      },
    });
  };

  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      {selectedCategory ? (
        <Content
          manuals={USER_MANUAL_LINKS.filter(
            (manual) => manual.category_id === selectedCategory
          )}
        />
      ) : (
        <Categories onSelect={handleCategorySelect} />
      )}
    </section>
  );
};

export default UserManualPage;
